import {
  computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { GetLocalStorage, SetLocalStorage } from '../utilities/cryptography';
import { ALLERGY_OPTIONS, ALLERGY_OPTIONS_CN, CURRENT_MEDICINE_TAKEN_OPTIONS, CURRENT_MEDICINE_TAKEN_OPTIONS_CN, MODALITY, PAST_DISEASE_OPTIONS, PAST_DISEASE_OPTIONS_CN, SYMPTOM_OPTIONS, SYMPTOM_OPTIONS_CN, USER_INFO } from '../constants/storage-keys';
import { navigate } from 'gatsby';
import { CURRENT_PLATFORM } from '../constants/settings';
import { Gender, PAGE_SIZE } from '../constants/options';
import { ProfileTemplate } from '../utilities/profile';
import { GetApiLang, GetLangKey, GetUserProfile, Language } from '../utilities/general';
import { FAxios } from '../utilities/file-network';


export default class BookingStore {
  loading: boolean = false;

  fetchingPractitioners: boolean = false;

  loadingTimeslots: boolean = false;

  loadingServices: boolean = false;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      loading: observable,
      fetchingPractitioners: observable,
      loadingServices: observable,
      loadingTimeslots: observable,
    });
    this.rootStore = rootStore;
  }

  searchPractitioners = async (skip: number, take: number = PAGE_SIZE, reqModel: any) => {
    this.fetchingPractitioners = true;
    try {
      const res = await Axios.post(`/api/Practitioner/Public/Search/${skip}/${take}?lang=${GetApiLang()}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.fetchingPractitioners = false;
    }
  };

  getPractitionerBySlug = async (slug: string) => {
    try {
      const res = await Axios.get(`/api/Practitioner/${slug}?lang=${GetApiLang()}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
    }
  };

  getBookingTimeslots = async (reqModel: any) => {
    this.loadingTimeslots = true;
    try {
      const res = await Axios.post(`/api/Practitioner/Booking/Timeslots`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingTimeslots = false;
    }
  };

  createBooking = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Practitioner/Booking?platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };


  createBookingWithProduct = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Practitioner/Booking/Product?platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  getBookingBookableInfo = async (reqModel: any) => {
    this.loadingServices = true;
    try {
      const res = await Axios.post(`/api/Practitioner/Booking/Product/Bookable`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingServices = false;
    }
  };

  getBookingBookableTimeSlots = async (reqModel: any) => {
    this.loadingServices = true;
    try {
      const res = await Axios.post(`/api/Practitioner/Booking/Product/Bookable/TimeSlots`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingServices = false;
    }
  };

}
